import useSignUpConfiguration from '../../../../common/hooks/useSignUpConfiguration';

export default useSignUpConfiguration;
